import {Component, Input, OnInit, QueryList, ViewChildren} from '@angular/core'
import {
  AbstractControl,
  FormControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidationErrors,
  Validators
} from '@angular/forms'
import {
  ElementUszkodzony,
  ParametryPowierzchni, ParametryPrzedmiotuSzklanego,
  ParametryUszkodzen,
  Uszkodzenie
} from '../../../../../../../../../store/zbior-uszkodzen/zbiorUszkodzen';
import {UuidGeneratorService} from '../../../../../../../../../services/id-generator/uuid-generator.service';
import {FormularzUszkodzenService} from '../formularz-uszkodzen.service';
import {isNumeric, max, min} from '../../../../../../../../../validators/ControlValidators';
import {ElementUszkodzenia} from '../../../../../../../../../services/slownik/types/element-uszkodzenia';
import {ObiektUszkodzenia} from '../interface/obiekt-uszkodzenia';
import {SlownikUszkodzen} from '../../../../../../../../../model/uszkodzenia/slownik-uszkodzen';
import {roundDecimal} from '../../../../../../../../../util/math-functions';
import {GrupaUszkodzenComponent} from '../formularz/grupa-uszkodzenia/grupa-uszkodzen.component';
import {unitValidatorFactory} from '../../../../../../../../../validators/unit-validator-factory';

@Component({
  selector: 'shared-uszkodzenia-w-lokalizacji',
  styleUrls: ['uszkodzenia-w-lokalizacji.component.scss'],
  templateUrl: './uszkodzenia-w-lokalizacji.component.html'
})
export class UszkodzeniaWLokalizacjiComponent implements ObiektUszkodzenia, OnInit {

  @ViewChildren(GrupaUszkodzenComponent) uszkodzeniaGrupowe!: QueryList<GrupaUszkodzenComponent>;

  public readonly SZEROKOSC_USZKODZENIA_FORM_FIELD = 'szerokosc';
  public readonly WYSOKOSC_USZKODZENIA_FORM_FIELD = 'wysokosc';
  public readonly KOMENTARZ_USZKODZENIA_FORM_FIELD = 'komentarz';
  private readonly WARTOSC_USZKODZENIA_FORM_FIELD = 'wartosc';
  private readonly MATERIAL_WYKONCZENIA_FORM_FIELD = 'materialWykonczenia';
  private readonly RODZAJ_POWIERZCHNI_FORM_FIELD = 'rodzajPowierzchni';
  private readonly BRAK_NAZWY_ELEMENTU_USZKODZONEGO = '';

  formularzWidoczny!: boolean

  @Input()
  elementUszkodzenia!: ElementUszkodzenia

  @Input()
  formularzLokalizacjiUszkodzenia!: UntypedFormGroup

  @Input()
  czyBrakObrazka = false;

  @Input()
  pokazWyczyscElement = true;

  @Input()
  czyUszkodzenieDomyslnieWybrane = false;

  @Input()
  czyWalidacjaWartosciUszkodzeniaWzgledemWymiarowLokalizacji = false;

  @Input()
  pokazWartosc = true;

  @Input()
  pokazSzerokosc = false;

  @Input()
  pokazWysokosc = false;

  @Input()
  pokazKomentarz = false;

  @Input()
  etykietaWartosci = '';


  @Input()
  czyGrupowac = false

  @Input()
  maksymalnaIloscElementow?: number

  @Input()
  minimalnyWymiar?: number

  @Input()
  maksymalnyWymiar?: number

  formularzUszkodzenia!: UntypedFormGroup

  checkBoxStyle = '';

  maksymalnaWartoscUszkodzenia!: number;

  readonly maksymalnaWartosc = 50;
  readonly minimalnaWartosc = 0.1;

  constructor(private fb: UntypedFormBuilder, private formularzUszkodzenService: FormularzUszkodzenService, private idGenerator: UuidGeneratorService) {
  }

  ngOnInit(): void {
    this.inicjujFormularz();
    this.iniciujIstniejaceUszkodzenia();
    if (this.czyUszkodzenieDomyslnieWybrane) {
      this.checkBoxStyle = 'checked up';
      this.formularzUszkodzenService.dodajPodformularzUszkodzenia({
        formularz: this.formularzUszkodzenia,
        nazwa: this.elementUszkodzenia.nazwa
      })
      this.formularzWidoczny = true
    }
    if (this.pokazWartosc && this.czyWalidacjaWartosciUszkodzeniaWzgledemWymiarowLokalizacji && !this.czyGrupowac) {
      this.formularzLokalizacjiUszkodzenia.valueChanges.subscribe(() => {
        this.wyznaczMaksymalnaPowierzchnieUszkodzenia()
        this.aktualizujPowierzchnieUszkodzenia(this.formularzUszkodzenia.controls.wartosc.value)
      })
    }
  }

  private inicjujFormularz(): void {
    this.formularzUszkodzenia = this.fb.group({
      materialWykonczenia: [null, this.utworzWalidacjeDlaMaterialuWykonczenia()],
      rodzajPowierzchni: [null, this.utworzWalidacjeDlaRodzajuPowierzchni()]
    })
    if (this.pokazWartosc && !this.czyGrupowac) {
      this.formularzUszkodzenia.addControl('wartosc', new FormControl<number | null>(this.elementUszkodzenia.domyslnaWartoscUszkodzenia,
        this.czyWalidacjaWartosciUszkodzeniaWzgledemWymiarowLokalizacji ? this.utworzWalidacjeDlaPowierzchniUszkodzenia()
          : this.utworzWalidacjeDlaMinimalnejWartosciUszkodzenia()))
    }
    if (this.pokazSzerokosc) {
      this.formularzUszkodzenia.addControl('szerokosc', new FormControl<number | null>(null))
    }
    if (this.pokazWysokosc) {
      this.formularzUszkodzenia.addControl('wysokosc', new FormControl<number | null>(null))
    }
    if (this.pokazKomentarz) {
      this.formularzUszkodzenia.addControl('komentarz', new FormControl<string | null>(null))
    }
  }

  private utworzWalidacjeDlaMinimalnejWartosciUszkodzenia(): ValidationErrors {
    const walidacje = [
      Validators.required,
      unitValidatorFactory(this.elementUszkodzenia.jednostka),
      min(this.elementUszkodzenia.minimalnaWartoscUszkodzenia)
    ]
    if (this.elementUszkodzenia.maksymalnaWartoscUszkodzenia) {
      walidacje.push(max(this.elementUszkodzenia.maksymalnaWartoscUszkodzenia))
      this.maksymalnaWartoscUszkodzenia = this.elementUszkodzenia.maksymalnaWartoscUszkodzenia
    }
    return {validators: walidacje, updateOn: 'change'}
  }

  private utworzWalidacjeDlaPowierzchniUszkodzenia(): ValidationErrors {
    const walidacje = [Validators.required, isNumeric(), min(this.elementUszkodzenia.minimalnaWartoscUszkodzenia),
      (control: AbstractControl) => max(this.maksymalnaWartoscUszkodzenia)(control)]
    return {validators: walidacje, updateOn: 'change'}
  }

  private utworzWalidacjeDlaMaterialuWykonczenia(): ValidationErrors | null {
    return this.elementUszkodzenia.materialyWykonczenia && !this.czyGrupowac ? Validators.required : null
  }

  private utworzWalidacjeDlaRodzajuPowierzchni(): ValidationErrors | null {
    return this.elementUszkodzenia.rodzajePowierzchni ? Validators.required : null
  }

  private iniciujIstniejaceUszkodzenia(): void {
    setTimeout(() => {
      const listaUszkodzenIstniejacych = this.formularzUszkodzenService.pobierzIstniejaceUszkodzenia()
        .filter(u => u.nazwa.toUpperCase() === this.elementUszkodzenia.nazwa.toUpperCase())

      if (listaUszkodzenIstniejacych.length >= 1) {
        if (this.czyUszkodzeniaGrupowe(listaUszkodzenIstniejacych)) {
          this.inicjujUszkodzeniaGrupowe(listaUszkodzenIstniejacych);
        } else {
          this.inicjujUszkodzeniaPojedyczne(listaUszkodzenIstniejacych);
        }
        if (!this.czyUszkodzenieDomyslnieWybrane) {
          this.przelaczStanFormularza(true)
        }
      }
    });
    if (this.czyWalidacjaWartosciUszkodzeniaWzgledemWymiarowLokalizacji) {
      this.wyznaczMaksymalnaPowierzchnieUszkodzenia();
    }
  }

  private inicjujUszkodzeniaGrupowe(listaUszkodzenIstniejacych: Uszkodzenie<ParametryPowierzchni>[]): void {
    this.uszkodzeniaGrupowe
      .find(gc => gc.elementUszkodzenia.nazwa === this.elementUszkodzenia.nazwa)
      ?.inicjujIstniejaceUszkodzenie(listaUszkodzenIstniejacych)
  }

  private inicjujUszkodzeniaPojedyczne(listaUszkodzenIstniejacych: Uszkodzenie<ParametryPrzedmiotuSzklanego>[]): void {
    const uszkodzenieIstniejace = listaUszkodzenIstniejacych.find(m => m !== undefined)
    uszkodzenieIstniejace?.elementyUszkodzone.forEach(e => {
      if (e.nazwa !== this.BRAK_NAZWY_ELEMENTU_USZKODZONEGO) {
        this.formularzUszkodzenia.controls[e.rodzaj].setValue(e.nazwa)
      }
    })
    if (this.formularzUszkodzenia.controls[this.WARTOSC_USZKODZENIA_FORM_FIELD]) {
      this.formularzUszkodzenia.controls[this.WARTOSC_USZKODZENIA_FORM_FIELD].setValue(uszkodzenieIstniejace?.parametry.wartosc)
    }
    if (this.formularzUszkodzenia.controls[this.SZEROKOSC_USZKODZENIA_FORM_FIELD]) {
      this.formularzUszkodzenia.controls[this.SZEROKOSC_USZKODZENIA_FORM_FIELD].setValue(uszkodzenieIstniejace?.parametry.szerokosc)
    }
    if (this.formularzUszkodzenia.controls[this.WYSOKOSC_USZKODZENIA_FORM_FIELD]) {
      this.formularzUszkodzenia.controls[this.WYSOKOSC_USZKODZENIA_FORM_FIELD].setValue(uszkodzenieIstniejace?.parametry.wysokosc)
    }
    if (this.formularzUszkodzenia.controls[this.KOMENTARZ_USZKODZENIA_FORM_FIELD]) {
      this.formularzUszkodzenia.controls[this.KOMENTARZ_USZKODZENIA_FORM_FIELD].setValue(uszkodzenieIstniejace?.parametry.komentarz)
    }
  }

  private czyUszkodzeniaGrupowe(listaUszkodzenIstniejacych: Uszkodzenie<any>[]): boolean {
    return listaUszkodzenIstniejacych.map(u => Object.values(SlownikUszkodzen).find(su => su.nazwa === u.nazwa))
      .map(su => su.czyGrupowac)
      .includes(true)
  }

  przelaczStanFormularza($event: any): void {
    if ($event) {
      this.ustawDomyslnaWartoscUszkodzenia();
      this.formularzUszkodzenService.dodajPodformularzUszkodzenia({
        formularz: this.formularzUszkodzenia,
        nazwa: this.elementUszkodzenia.nazwa
      })
      this.formularzUszkodzenService.sprawdzWalidacjeWDodanychFormularzach()
      this.formularzWidoczny = true
    } else if (!this.wszystkieWartosciWypelnione()) {
      this.resetujFormularz()
    }
    this.przelaczStanCheckboxa()
  }

  resetujFormularz(): void {
    this.formularzUszkodzenia.reset()
    this.formularzUszkodzenService.usunPodformularzUszkodzenia(this.elementUszkodzenia.nazwa)
  }

  aktualizujFormularz($event: { id: string, formGroup: UntypedFormGroup }): void {
    this.formularzUszkodzenia = $event.formGroup
  }

  wyczyscFormularz(): void {
    this.formularzWidoczny = false
    this.resetujFormularz()
    this.przelaczStanCheckboxa()
  }

  utworzObiektUszkodzenia<N extends ParametryUszkodzen>(parametryUszkodzenia: N, id?: string): Uszkodzenie<N> {
    const uszkodzenie = {} as Uszkodzenie<N>;
    uszkodzenie.identyfikator = this.idGenerator.generateUuId();
    uszkodzenie.nazwa = this.elementUszkodzenia.nazwa;
    uszkodzenie.opis = this.elementUszkodzenia.opis;
    uszkodzenie.elementyUszkodzone = [];

    parametryUszkodzenia.jednostka = this.elementUszkodzenia.jednostka;

    parametryUszkodzenia.wartosc = this.ustawWartosc(id);
    uszkodzenie.parametry = parametryUszkodzenia;

    if (this.elementUszkodzenia.atrybuty?.pokazRodzajePowierzchni) {
      const opisRodzajuPowierzchni = this.elementUszkodzenia.rodzajePowierzchni
        .find(rodzaj => rodzaj.nazwa === this.wartoscFormularza(this.RODZAJ_POWIERZCHNI_FORM_FIELD))?.opis;
      const rodzajPowierzchni = {} as ElementUszkodzony;
      rodzajPowierzchni.nazwa = this.wartoscFormularza(this.RODZAJ_POWIERZCHNI_FORM_FIELD);
      rodzajPowierzchni.rodzaj = this.RODZAJ_POWIERZCHNI_FORM_FIELD;
      rodzajPowierzchni.opis = (opisRodzajuPowierzchni) ? opisRodzajuPowierzchni : '';
      uszkodzenie.elementyUszkodzone.push(rodzajPowierzchni);
    }

    if (this.elementUszkodzenia.atrybuty?.pokazMaterialyWykonczenia) {
      const nazwaMaterialuWykonczenia = this.nazwaMaterialuWykonczenia(id);
      const opisMaterialuWykonczenia = this.elementUszkodzenia.materialyWykonczenia
          .find(material => material.nazwa === nazwaMaterialuWykonczenia)?.opis;
      const materialWykonczenia = {} as ElementUszkodzony;
      materialWykonczenia.nazwa = this.wartoscFormularza(this.MATERIAL_WYKONCZENIA_FORM_FIELD);
      materialWykonczenia.rodzaj = this.MATERIAL_WYKONCZENIA_FORM_FIELD;
      materialWykonczenia.opis = (opisMaterialuWykonczenia) ? opisMaterialuWykonczenia : '';
      uszkodzenie.elementyUszkodzone.push(materialWykonczenia);
    }

    return uszkodzenie;
  }

  przelaczStanCheckboxa(): void {
    if (this.formularzWidoczny) {
      this.checkBoxStyle = 'checked up';
    } else if (this.wszystkieWartosciWypelnione()) {
      this.checkBoxStyle = (this.checkBoxStyle === 'checked') ? 'checked up' : 'checked';
      // Dla uszkodzeń nieposiadających atrybutów usuwamy uszkodzenie z formularza w momencie odznaczenia checkbox'a
      if (!this.elementUszkodzenia.atrybuty) {
        this.resetujFormularz()
      }
    } else {
      this.checkBoxStyle = '';
    }
  }

  wartoscFormularza(param: string): any {
    return this.formularzUszkodzenia.get(param)?.value;
  }

  wszystkieWartosciWypelnione(): boolean {
    let result = true;
    Object.keys(this.formularzUszkodzenia.controls).forEach(key => result = Boolean(result && this.formularzUszkodzenia.get(key)?.valid));
    return result;
  }

  czyUszkodzenieWybraneNaFormularzu(): boolean {
    return this.checkBoxStyle !== '';
  }

  wyznaczMaksymalnaPowierzchnieUszkodzenia(): void {
    switch (this.elementUszkodzenia.nazwa) {
      case SlownikUszkodzen.SCIANA_WEWNETRZNA.nazwa:
        this.ustawMaksymalnaPowierzchnieUszkodzeniaDlaSciany();
        break;
      case SlownikUszkodzen.LISTWY_PRZYPODLOGOWE.nazwa:
        this.ustawMaksymalnaDlugoscUszkodzeniaDlaObwoduPodlogi();
        break;
      default:
        this.ustawMaksymalnaPowierzchnieUszkodzeniaDlaSufituPodlogi();
        break;
    }
  }

  ustawMaksymalnaPowierzchnieUszkodzeniaDlaSciany(): void {
    this.maksymalnaWartoscUszkodzenia = this.formularzLokalizacjiUszkodzenia.controls.szerokosc.value && this.formularzLokalizacjiUszkodzenia.controls.dlugosc.value
    && this.formularzLokalizacjiUszkodzenia.controls.wysokosc.value ?
      roundDecimal(2 * (this.formularzLokalizacjiUszkodzenia.controls.wysokosc.value * this.formularzLokalizacjiUszkodzenia.controls.szerokosc.value) +
        2 * (this.formularzLokalizacjiUszkodzenia.controls.wysokosc.value * this.formularzLokalizacjiUszkodzenia.controls.dlugosc.value)) : 0;
  }

  ustawMaksymalnaPowierzchnieUszkodzeniaDlaSufituPodlogi(): void {
    this.maksymalnaWartoscUszkodzenia = this.formularzLokalizacjiUszkodzenia.controls.szerokosc?.value && this.formularzLokalizacjiUszkodzenia.controls.dlugosc?.value ?
      roundDecimal(this.formularzLokalizacjiUszkodzenia.controls.szerokosc.value * this.formularzLokalizacjiUszkodzenia.controls.dlugosc.value) : 0;
  }

  ustawMaksymalnaDlugoscUszkodzeniaDlaObwoduPodlogi(): void {
    this.maksymalnaWartoscUszkodzenia = this.formularzLokalizacjiUszkodzenia.controls.szerokosc?.value && this.formularzLokalizacjiUszkodzenia.controls.dlugosc?.value ?
      roundDecimal(2 * this.formularzLokalizacjiUszkodzenia.controls.szerokosc.value + 2 * this.formularzLokalizacjiUszkodzenia.controls.dlugosc.value) : 0;
  }

  aktualizujPowierzchnieUszkodzenia(value: number): void {
    if (this.maksymalnaWartoscUszkodzenia < value) {
      this.formularzUszkodzenia.controls.wartosc.setErrors({max: true})
    } else {
      this.formularzUszkodzenia.controls.wartosc.setErrors({max: null})
    }
    setTimeout(() => {
      this.formularzUszkodzenia.controls.wartosc.updateValueAndValidity({onlySelf: false, emitEvent: true})
    });
  }

  ustawDomyslnaWartoscUszkodzenia(): void {
    if (this.wartoscFormularza(this.WARTOSC_USZKODZENIA_FORM_FIELD) == null && Boolean(this.elementUszkodzenia.domyslnaWartoscUszkodzenia)) {
      this.formularzUszkodzenia.controls.wartosc.setValue(this.elementUszkodzenia.domyslnaWartoscUszkodzenia);
    }
  }

  private ustawWartosc(id: string | undefined): any {
    return this.czyGrupowac && id ? this.znajdzPodFormularz(id)?.get(this.WARTOSC_USZKODZENIA_FORM_FIELD)?.value :
      this.wartoscFormularza(this.WARTOSC_USZKODZENIA_FORM_FIELD);
  }

  private nazwaMaterialuWykonczenia(id: string | undefined): string {
    return this.czyGrupowac && id ? this.znajdzPodFormularz(id)?.get(this.MATERIAL_WYKONCZENIA_FORM_FIELD)?.value :
      this.wartoscFormularza(this.MATERIAL_WYKONCZENIA_FORM_FIELD);
  }

  private znajdzPodFormularz(id: string | undefined): UntypedFormGroup | undefined {
    return this.uszkodzeniaGrupowe.map(e => e.formularze.find(v => v.id === id)?.formularz).pop();
  }
}
